import { FeatureResponse, No, Unclear, Unresolved, Yes } from "./FeatureResponse";
import { Syndrome } from "./Syndrome";

export class Focal extends Syndrome {

    getName() {
        return "Focal";
    }

    checkMandatorySeizures(seizures: any[]): FeatureResponse {
        for (const seizure of seizures) {
            if(seizure.mainType === "focal") 
                return new Yes("Mandatory: Focal seizures present.");
        }
        return new No("Mandatory focal seizures not present.");
    }

}